"use strict";
const redux_1 = require('redux');
const react_router_redux_1 = require('react-router-redux');
const auth_1 = require('./reducers/auth');
const connection_1 = require('./reducers/connection');
const tasks_1 = require('./reducers/tasks');
const sessions_1 = require('./reducers/sessions');
const snackbar_1 = require('./reducers/snackbar');
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = redux_1.combineReducers({
    routing: react_router_redux_1.routerReducer,
    auth: auth_1.default,
    connection: connection_1.default,
    sessions: sessions_1.default,
    snackbar: snackbar_1.default,
    tasks: tasks_1.default,
});



/** WEBPACK FOOTER **
 ** ./src/reducer.ts
 **/